/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './services/auth.service';
import { LoginComponent } from './login/login/login.component';
import { UsuarioService } from './services/usuario/usuario.service';
import { Estabelecimento } from './pages/estabelecimentos/estabelecimento';
import { AuthInterceptor } from './services/Auth.interceptor';
import { DataTablesModule } from 'angular-datatables';
import { EstabelecimentoService } from './services/estabelecimento/estabelecimento.service';
import { DefinicaoSenhaComponent } from './login/definicao-senha/definicao-senha.component';
import { LoaderService } from './services/loader/loader.service';
import { DocumentoService } from './services/documento/documento.service';
import { NotificacaoService } from './services/notificacao/notificacao.service';
import { RelatorioService } from './services/relatorio/relatorio.service';


declare var $:JQueryStatic;

@NgModule({
	declarations: [AppComponent, LoginComponent, DefinicaoSenhaComponent],
	imports: [
        BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		NgbModule.forRoot(),
		ThemeModule.forRoot(),
		CoreModule.forRoot(),
		DataTablesModule
	],
	bootstrap: [AppComponent],
	providers: [
		{ provide: APP_BASE_HREF, useValue: '/', },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},NotificacaoService,
		AuthService,
		LoaderService,
        UsuarioService,
        RelatorioService,
        DocumentoService,
		EstabelecimentoService
	],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts